// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IoEllipsisVertical = function IoEllipsisVertical (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"416","r":"48"}},{"tag":"circle","attr":{"cx":"256","cy":"96","r":"48"}}]})(props);
};
